import { Link, useNavigate } from "react-router-dom";

/** Lib Imports */
import { Button } from "primereact/button";

/** Context */
import { useMenu } from "../../context/MenuContext";

/** CSS */
import "./NotFound.scss";

const NotFound = () => {

  const navigate = useNavigate();
  const { toggleAdminMenu } = useMenu();

  const handleNavigateHome = () => {
    toggleAdminMenu(false);
    navigate("/");
  }

  return (
    <div className="not-found">
      <div className="error-img">

        <img src="/images/404-error.png" alt="404 Not Found" className="error-image" />
      </div>
      <p className="error-title">Oops! Page Not Found</p>
      <p className="error-message">
        The page you are looking for might have been removed, renamed, or is
        temporarily unavailable.
      </p>
      <Button
        as={Link}
        size="large"
        className="btn  btn secondary-btn"
        variant="primary"
        onClick={handleNavigateHome}

        label="Go to Home Page"
      />
    </div>
  );
};

export default NotFound;
